import React from "react";
import RelevesDetailles from "./RelevesDetailles";

const RelevesDetaillesVente = () => <RelevesDetailles tierLabel="Client" tiersApi="Clients" />;

export default RelevesDetaillesVente;
